import { Service, StatusKey, OverallKey } from './types';

export const SERVICES: Service[] = [
//   { id: "qualis-email",   name: "Primary Email Server",    url: "https://qualis-email-server.vercel.app", group: "Email" },
  { id: "xpress-console",   name: "Xpress Suite Console",    url: "https://xpress.loop.com.na", group: "Administration"     },
//   { id: "loop-api",       name: "Loop Core API",           url: "https://api.loop.com.na",                group: "Core"      },
  { id: "xpress-erp-api",   name: "XPRESS ERP API",    url: "https://erp-api.loop.com.na", group: "ERP"     },
  { id: "xpress-erp-console",   name: "XPRESS ERP Console",    url: "https://erp.loop.com.na", group: "ERP "     },
  { id: "loop-qms",       name: "QMS SERVER",              url: "https://qms.loop.com.na",                group: "Portals"   },
  { id: "loop-whatsapp",  name: "WhatsApp API Service",    url: "https://whatsapp.loop.com.na",           group: "Messaging Automation" }, // http://159.223.29.101:4001
  { id: "loop-bucket",    name: "Bucket Storage",          url: "https://bucket.loop.com.na",             group: "Storage"   },
  { id: "loop-sels",      name: "Self Service",            url: "https://sels.loop.com.na",               group: "Core"      },
  { id: "loop-mail",      name: "Secondary Mail Service",  url: "https://emails.loop.com.na",               group: "Email"     },
];

export const STATUS_LABELS: Record<StatusKey, string> = {
  checking: 'Checking',
  online:   'Operational',
  degraded: 'Degraded',
  offline:  'Offline',
};

export const STATUS_COLORS: Record<StatusKey, string> = {
  online:   '#a8ff78',
  degraded: '#ffcc44',
  offline:  '#ff4444',
  checking: '#555',
};

export const OVERALL_MESSAGES: Record<OverallKey, { text: string; color: string }> = {
  all_good: { text: 'All Systems Operational', color: '#a8ff78' },
  partial:  { text: 'Partial Outage Detected', color: '#ff4444' },
  degraded: { text: 'Degraded Performance',    color: '#ffcc44' },
  checking: { text: 'Running Diagnostics...',  color: '#888'    },
};
